import * as React from 'react'

interface IProps {
	items: string[]
	className?: string
	listStyle?: 'circle' | 'check'
}

export function List({ items, className = '', listStyle = 'circle' }: IProps) {
	const additionalClass = listStyle === 'check' ? 'cc-list_check' : ''
	return (
		<ul className={`cc-list ${className} ${additionalClass}`}>
			{
				items.map((item, i) =>
					<li key={item + i}>
						{
							listStyle === 'check' &&
							<i className="glyphicon glyphicon-ok" />
						}
						<span>
							{ item }
						</span>
					</li>
				)
			}
		</ul>
	)
}
